import React, { useEffect, useState } from "react";
import InspectorOverview from "./InspectorOverview";
import { INSPECTOR_PANIC_STEPS } from "./panicConfig";

export default function InspectorPortalPage() {
  const [me, setMe] = useState(null);

  useEffect(() => {
    fetch("/api/me.php", { credentials: "include" })
      .then((res) => res.json().catch(() => null))
      .then((data) => setMe(data || null))
      .catch(() => setMe(null));
  }, []);

  async function handleLogout() {
    try {
      await fetch("/api/logout.php", { method: "POST", credentials: "include" });
    } finally {
      window.location.href = "/login";
    }
  }

  return (
    <div className="min-h-screen bg-slate-100 p-4 md:p-6">
      <div className="mx-auto max-w-6xl space-y-4">
        <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
          <div className="text-xs font-semibold uppercase tracking-wide text-sky-600">Portale ispettore</div>
          <div className="mt-2 text-2xl font-bold text-slate-950">{me?.azienda_nome || "Area ispettore"}</div>
          <div className="mt-2 text-sm text-slate-600">
            Accesso dedicato alla sola documentazione ispettiva dell'azienda.
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            <button type="button" onClick={handleLogout} className="rounded-xl border px-4 py-2 text-sm font-semibold hover:bg-slate-50">
              Esci
            </button>
          </div>
        </div>

        <InspectorOverview steps={INSPECTOR_PANIC_STEPS} />
      </div>
    </div>
  );
}
